const addCommas = (num) => {
  var num_parts = String(num).split(".");
  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return num_parts.join(".");
};

export { addCommas };
